import { render, staticRenderFns } from "./InventoryLabResultEdit.vue?vue&type=template&id=09f463ce"
import script from "./InventoryLabResultEdit.vue?vue&type=script&lang=js"
export * from "./InventoryLabResultEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f463ce')) {
      api.createRecord('09f463ce', component.options)
    } else {
      api.reload('09f463ce', component.options)
    }
    module.hot.accept("./InventoryLabResultEdit.vue?vue&type=template&id=09f463ce", function () {
      api.rerender('09f463ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryLabResult/InventoryLabResultEdit.vue"
export default component.exports